import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
import { derived } from "svelte/store";
import { getOrganization } from "../api/organizations";

export const organizationsStore = derived(
  userStore,
  ($userStore, set) => {
    if (!$userStore?.organizationId) {
      set(null);
      return;
    }

    getOrganization($userStore?.organizationId).then((data) => {
      set(data.organization);
    });
  },
  null,
);
